import {
  AudienceSegmentDefinition,
  defaultAudienceSegmentDefinition,
} from "@intentsify/types";
import { atom } from "jotai";

export const AudienceSegmentsState = {
  audienceSegmentDefinitionAtom: atom<AudienceSegmentDefinition>(
    defaultAudienceSegmentDefinition
  ),
};
